<template>
  <div class="recent-items">
    <recent-actions />
    <tol-table :table-data="recentItems" :columns="columns" :class="{ small: isProfileListing }">
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'initiatedAt' ? currentSortDirection : 'none'"
          field-name="initiatedAt"
          @change="onSortOrderChange"
          >{{ $t('recentItems.listing.labels.dateLastViewed') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'recentItem' ? currentSortDirection : 'none'"
          field-name="recentItem"
          @change="onSortOrderChange"
          >{{ $t('recentItems.listing.labels.recentItem') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'objectType' ? currentSortDirection : 'none'"
          field-name="objectType"
          @change="onSortOrderChange"
          >{{ $t('recentItems.listing.labels.recentItemType') }}</th-sortable
        >

        <th></th>
      </template>
      <template v-slot:objectReferenceNumber="{ value }">
        <router-link :to="`${value.description.urlPart}/${value.objectReferenceNumber}`">
          <font-awesome-icon :icon="value.description.icon" />
          {{ value.description.label }}
        </router-link>
      </template>
      <template v-slot:initiatedAt="{ value }">
        {{ value.initiatedAt | formatDateTime }}
      </template>

      <template v-slot:click-action="{ value }">
        <td>
          <div class="delete-btn">
            <font-awesome-icon icon="trash-alt" @click="onDeleteItem(value)" />
          </div>
        </td>
      </template>
    </tol-table>

    <Pagination
      :records-per-page="itemsPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      :class="{ small: isProfileListing }"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import TolTable from '@/app/components/TolTable';
import Pagination from '@/app/components/Pagination';
import ThSortable from '@/app/components/ThSortable';
import RecentActions from '@/app/features/recent-items/components/RecentActions.vue';
import {
  RecentItemsGetters,
  RecentItemsActions
} from '@/app/features/recent-items/recent-items.keys';
import { AppActions } from '@/app/app.keys';

export default {
  name: 'RecentItems',
  components: {
    TolTable,
    Pagination,
    ThSortable,
    RecentActions
  },
  props: {
    isProfileListing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    recentItemsPerPage() {
      return this.$store.getters[RecentItemsGetters.RecentItemsPerPage];
    },
    currentPage() {
      return this.$store.getters[RecentItemsGetters.RecentItemsListingOffset];
    },
    recentItemsCount() {
      return this.$store.getters[RecentItemsGetters.RecentItemsFilteredSortedRecordCount];
    },
    recentItems() {
      return this.$store.getters[RecentItemsGetters.RecentItemsList];
    },
    columns() {
      return ['initiatedAt', 'objectReferenceNumber', 'objectType'];
    },
    currentSortField() {
      return this.$store.getters[RecentItemsGetters.SortBy];
    },
    currentSortDirection() {
      return this.$store.getters[RecentItemsGetters.SortDirection];
    },
    itemsPerPage() {
      return this.$store.getters[RecentItemsGetters.RecentItemsPerPage];
    },
    recordCount() {
      return this.$store.getters[RecentItemsGetters.RecentItemsFilteredRecordCount];
    },
    userId() {
      return this.$store.state.currentUser.id;
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('recentItems.listing.title'));
  },
  methods: {
    onChangePaginationParams(event) {
      this.$store.dispatch(RecentItemsActions.SetRecentItemsPaginationParameters, {
        pagination: event,
        userId: this.userId
      });
    },
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(RecentItemsActions.SetRecentItemsSortOrder, {
        sortOrder,
        userId: this.userId
      });
    },
    onDeleteItem(value) {
      this.$store.dispatch(RecentItemsActions.DeleteRecentItems, {
        userId: this.userId,
        recentItemId: value.id,
        all: false
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../styles/colors.scss';
@import '../../styles/variables.scss';

.delete-btn {
  position: relative;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 100%;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    background-color: $light-grey-2;
    color: $red;
    cursor: pointer;
  }
}
</style>
